














































import Vue from 'vue';
import Sex from './Sex.vue';
import SubscribeTime from './SubscribeTime.vue';
import SubscribeScene from './SubscribeScene.vue';
import Area from './Area.vue';
import Remark from './Remark.vue';
import Group from './Group.vue';
import Member from './Member.vue';
import Interact from './Interact.vue';
import Trace from './Trace.vue';
import Score from './Score.vue';
import Custom from './Custom.vue';
import Topic from './Topic.vue';
import customerVuex from '../../../customer/vuex/common';
import customerClient from '../../../customer/apis';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    Sex,
    SubscribeTime,
    SubscribeScene,
    Area,
    Topic,
    Remark,
    Group,
    Member,
    Interact,
    Trace,
    Score,
    Custom,
  },
  data() {
    return {
      showOtherSettings: false,
    };
  },
  methods: {
    loadPropsOfFields() {
      customerClient.getProps().success((r) => {
        this.$store.commit('SET_CUSTOMER_PROPS', r.props);
      });
    },
  },
  mounted() {
    if (this.isFilterScore ||
        this.isFilterScoreSum ||
        this.isFilterInteract ||
        this.isFilterTrace ||
        this.isFilterCustom) {
      this.showOtherSettings = true;
    }
    this.loadPropsOfFields();
  },
});
